<template>
  <div id="invoice-page" v-if="report">
    <div class="flex flex-wrap items-center justify-between">
      <h1 class="mb-base">Reports</h1>
      <vx-input-group class="mb-base mr-3">
        <vs-input v-model="mailTo" placeholder="Email" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button type="border" @click="Send()" class="whitespace-no-wrap"
              >Send Report</vs-button
            >
          </div>
        </template>
      </vx-input-group>
      <div class="flex items-center">
        <vs-button
          class="mb-base mr-3"
          type="border"
          icon-pack="feather"
          @click="downloadFile"
          icon="icon icon-download"
          id="download"
        >
          Download</vs-button
        >
        <vs-button
          class="mb-base mr-3"
          icon-pack="feather"
          icon="icon icon-file"
          @click="printInvoice"
          >Print
        </vs-button>
      </div>
    </div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="download === true ? true : false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      @progress="nus($event)"
      filename="Report"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="95%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="main-wrapper" style="margin-left: 50px; margin-top: 50px">
          <span class="float-right mt-2"> USA Property 70 hour / 8 day </span>
          <h1 class="mt-4 text-center ml-32">Drivers Daily Log</h1>
          <h3 class="text-center mt-4 mb-6">
            {{ report.created.slice(0, 10) }}
          </h3>
          <div class="first-wrapper">
            <div class="left-wrapper">
              <div class="driver">
                <div class="name">
                  <h6>Driver</h6>
                  <span
                    >{{ report.driver.name }} {{ report.driver.last_name }}
                  </span>
                </div>
                <div class="id">
                  <h6>ID</h6>
                  <span>{{ report.driver.id }}</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>DL Number</h6>
                  <span>{{ report.driver.driver_license_number }} </span>
                </div>
                <div class="id">
                  <h6>ST</h6>
                  <span>{{ report.driver.dr_li_issue_state }}</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>ELD ID</h6>
                  <span>GNA001</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>ELD Provider</h6>
                  <span>Utech, Inc</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>Carrier</h6>
                  <span>Western America Express, LLC</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>USDOT #</h6>
                  <span>2571783</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>Main Office</h6>
                  <span>10540 Sunburst Dr RCH Cucamonga, CA 91730</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>Home Terminal</h6>
                  <span>10540 Sunburst Dr RCH Cucamonga, CA 91730</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>From Address</h6>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>Shipping Docs</h6>
                  <span>none, 111X6SRS2</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>Start/End Engine Hours</h6>
                  <span>13855.8-13871.4</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>
                    Malfunction <br />
                    Indicators
                  </h6>
                  <span>No</span>
                </div>
              </div>
              <div class="driver">
                <div class="name">
                  <h6>Unidentified Driver Records</h6>
                </div>
                <div class="id">
                  <span>No</span>
                </div>
              </div>
            </div>
            <div class="right-wrapper">
              <div class="driver">
                <h6>Co-Drivers (ID)</h6>
                <span>AMIRI ZAMIR (AZ1984)</span>
              </div>
              <div class="driver">
                <h6>Time Zone</h6>
                <div class="id">
                  <span>PS</span>
                </div>
              </div>
              <div class="driver">
                <h6>Time Zone Offset</h6>
                <div class="id">
                  <span>UTC-7</span>
                </div>
              </div>
              <div class="driver">
                <h6>24 Period Starting Time</h6>
                <div class="id">
                  <span>Midnight</span>
                </div>
              </div>
              <div class="driver">
                <h6>Vehicles (VIN)</h6>
                <span>101 (4V4NC9EH2LN237780)</span>
              </div>
              <div class="driver">
                <h6>Exempt Driver Status</h6>
                <div class="id">
                  <span>No</span>
                </div>
              </div>
              <div class="driver">
                <h6>Trailers</h6>
                <span>bobtail, HV2201645</span>
              </div>
              <div class="driver">
                <h6>Distance</h6>
                <div class="id">
                  <span>423 mi</span>
                </div>
              </div>
              <div class="driver">
                <h6>To Address</h6>
              </div>
              <div class="driver">
                <h6>Start/End Odometer</h6>
                <div class="id">
                  <span>404383-405222</span>
                </div>
              </div>
              <div class="driver">
                <h6>Data Diagnostic Indicators</h6>
                <div class="id">
                  <span>No</span>
                </div>
              </div>
              <div class="driver">
                <h6>Notes</h6>
              </div>
            </div>
          </div>
          <div class="second-table">
            <div class="table-header">
              <h5>Odometer</h5>
            </div>
            <div class="second-table-body">
              <div class="vehicle">
                <h6>Vehicle</h6>
                <span>100</span>
              </div>
              <div class="vehicle">
                <h6>Start</h6>
                <span>404383</span>
              </div>
              <div class="vehicle">
                <h6>End</h6>
                <span>405222</span>
              </div>
              <div class="vehicle">
                <h6>Vehicle Miles</h6>
                <span>839 mi</span>
              </div>
              <div class="vehicle">
                <h6>Driver Miles</h6>
                <span>423 mi </span>
              </div>
              <div class="vehicle">
                <h6>PC/YM Miles</h6>
                <span>0 mi </span>
              </div>
            </div>
          </div>
          <div class="border-2 my-6 border-grey h-64">
            <line-svg :all="report.logs"></line-svg>
          </div>
          <div class="third-table">
            <div class="third-table-header">
              <h6>NO</h6>
              <h6>Status</h6>
              <h6>Time (PST)</h6>
              <h6>Duration</h6>
              <h6>Location</h6>
              <h6>Vehicle</h6>
              <h6>Odometer</h6>
              <h6>Eng. Hours</h6>
              <h6>Notes</h6>
            </div>
            <div
              class="third-table-infos"
              v-for="(log, i) in report.logs"
              :key="i"
            >
              <span>1</span>
              <p class="status">
                {{ log.status }}
                <span>DR</span>
              </p>
              <span
                >{{ log.cr_time.substr(11, 5) }}
                {{ log.cr_time.substr(11, 5) > "12:00" ? "PM" : "AM" }}</span
              >
              <span>{{
                new Date(log.dur * 1000)
                  .toUTCString()
                  .match(/(\d\d:\d\d:\d\d)/)[0]
              }}</span>
              <span>{{ log.country }}</span>
              <span>{{ log.vehicle }} </span>
              <span>{{ log.odometer }}</span>
              <span>{{ log.engine_hours }}</span>
              <span>{{ log.note || "-" }}</span>
            </div>
          </div>
        </div>
      </section>
    </VueHtml2pdf>
    <vx-card id="invoice-container" ref="DownloadComp">
      <div class="main-wrapper">
        <span class="float-right mt-2"> USA Property 70 hour / 8 day </span>
        <h1 class="mt-4 text-center ml-32">Drivers Daily Log</h1>
        <h3 class="text-center mt-4 mb-6">
          {{ report.created.slice(0, 10) }}
        </h3>
        <div class="first-wrapper">
          <div class="left-wrapper">
            <div class="driver">
              <div class="name">
                <h6>Driver</h6>
                <span
                  >{{ report.driver.name }} {{ report.driver.last_name }}
                </span>
              </div>
              <div class="id">
                <h6>ID</h6>
                <span>{{ report.driver.id }}</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>DL Number</h6>
                <span>{{ report.driver.driver_license_number }} </span>
              </div>
              <div class="id">
                <h6>ST</h6>
                <span>{{ report.driver.dr_li_issue_state }}</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>ELD ID</h6>
                <span>GNA001</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>ELD Provider</h6>
                <span>Utech, Inc</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>Carrier</h6>
                <span>Western America Express, LLC</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>USDOT #</h6>
                <span>2571783</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>Main Office</h6>
                <span>10540 Sunburst Dr RCH Cucamonga, CA 91730</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>Home Terminal</h6>
                <span>10540 Sunburst Dr RCH Cucamonga, CA 91730</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>From Address</h6>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>Shipping Docs</h6>
                <span>none, 111X6SRS2</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>Start/End Engine Hours</h6>
                <span>13855.8-13871.4</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>
                  Malfunction <br />
                  Indicators
                </h6>
                <span>No</span>
              </div>
            </div>
            <div class="driver">
              <div class="name">
                <h6>Unidentified Driver Records</h6>
              </div>
              <div class="id">
                <span>No</span>
              </div>
            </div>
          </div>
          <div class="right-wrapper">
            <div class="driver">
              <h6>Co-Drivers (ID)</h6>
              <span>AMIRI ZAMIR (AZ1984)</span>
            </div>
            <div class="driver">
              <h6>Time Zone</h6>
              <div class="id">
                <span>PS</span>
              </div>
            </div>
            <div class="driver">
              <h6>Time Zone Offset</h6>
              <div class="id">
                <span>UTC-7</span>
              </div>
            </div>
            <div class="driver">
              <h6>24 Period Starting Time</h6>
              <div class="id">
                <span>Midnight</span>
              </div>
            </div>
            <div class="driver">
              <h6>Vehicles (VIN)</h6>
              <span>101 (4V4NC9EH2LN237780)</span>
            </div>
            <div class="driver">
              <h6>Exempt Driver Status</h6>
              <div class="id">
                <span>No</span>
              </div>
            </div>
            <div class="driver">
              <h6>Trailers</h6>
              <span>bobtail, HV2201645</span>
            </div>
            <div class="driver">
              <h6>Distance</h6>
              <div class="id">
                <span>423 mi</span>
              </div>
            </div>
            <div class="driver">
              <h6>To Address</h6>
            </div>
            <div class="driver">
              <h6>Start/End Odometer</h6>
              <div class="id">
                <span>404383-405222</span>
              </div>
            </div>
            <div class="driver">
              <h6>Data Diagnostic Indicators</h6>
              <div class="id">
                <span>No</span>
              </div>
            </div>
            <div class="driver">
              <h6>Notes</h6>
            </div>
          </div>
        </div>
        <div class="second-table">
          <div class="table-header">
            <h5>Odometer</h5>
          </div>
          <div class="second-table-body">
            <div class="vehicle">
              <h6>Vehicle</h6>
              <span>100</span>
            </div>
            <div class="vehicle">
              <h6>Start</h6>
              <span>404383</span>
            </div>
            <div class="vehicle">
              <h6>End</h6>
              <span>405222</span>
            </div>
            <div class="vehicle">
              <h6>Vehicle Miles</h6>
              <span>839 mi</span>
            </div>
            <div class="vehicle">
              <h6>Driver Miles</h6>
              <span>423 mi </span>
            </div>
            <div class="vehicle">
              <h6>PC/YM Miles</h6>
              <span>0 mi </span>
            </div>
          </div>
        </div>
        <div class="border-2 my-6 border-grey h-64">
          <line-svg :all="report.logs"></line-svg>
        </div>
        <div class="third-table">
          <div class="third-table-header">
            <h6>NO</h6>
            <h6>Status</h6>
            <h6>Time (PST)</h6>
            <h6>Duration</h6>
            <h6>Location</h6>
            <h6>Vehicle</h6>
            <h6>Odometer</h6>
            <h6>Eng. Hours</h6>
            <h6>Notes</h6>
          </div>
          <div
            class="third-table-infos"
            v-for="(log, i) in report.logs"
            :key="i"
          >
            <span>1</span>
            <p class="status">
              {{ log.status }}
              <span>DR</span>
            </p>
            <span
              >{{ log.cr_time.substr(11, 5) }}
              {{ log.cr_time.substr(11, 5) > "12:00" ? "PM" : "AM" }}</span
            >
            <span>{{
              new Date(log.dur * 1000)
                .toUTCString()
                .match(/(\d\d:\d\d:\d\d)/)[0]
            }}</span>
            <span>{{ log.country }}</span>
            <span>{{ log.vehicle }} </span>
            <span>{{ log.odometer }}</span>
            <span>{{ log.engine_hours }}</span>
            <span>{{ log.note || "-" }}</span>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";
import LineSvg from "./components/graph/Svg.vue";
export default {
  data() {
    return {
      mailTo: "",
      blob: null,
      download: true,
      send: false,
    };
  },
  computed: {
    report() {
      return this.$store.state.event.reports;
    },
  },
  watch: {
    blob(val) {
      if (this.blob !== null) {
        const byteCharacters = new Blob([this.blob], {
          type: "application/pdf",
        });
        var file = new File([byteCharacters], "name.pdf", {
          type: "application/pdf",
        });
        let form = new FormData();
        form.append("pdf_file", file);
        form.append("id_log", this.$route.params.id);
        form.append("email", this.mailTo);
        this.$store
          .dispatch("log/ReportEmail", {
            form,
            id: this.$route.params.id,
          })
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
  },
  methods: {
    downloadFile() {
      this.download = true;
      this.$refs.html2Pdf.generatePdf();
    },
    nus(evt) {
      if (!this.download && evt) {
        this.blob = this.$refs.html2Pdf.pdfFile;
      }
    },
    Send() {
      this.$vs.loading();
      this.download = false;
      this.$refs.html2Pdf.generatePdf();
    },
    printInvoice() {
      window.print();
    },
  },
  components: { LineSvg, VueHtml2pdf },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
    // console.log(this.report);
  },
  created() {
    this.$store.dispatch("event/fetchDataReport", this.$route.params.id);
  },
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }
    #content-area {
      margin: 0 !important;
    }
    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }
    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
.vx-card {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: none !important;
  -webkit-transition: all 0.3s ease-in-out;
}

.vue-html2pdf .pdf-preview[data-v-1fd3ad26] {
  display: none !important;
}

.main-wrapper {
  h1 {
    font-size: 35px;
    text-align: center;
    color: #000;
  }

  .first-wrapper {
    display: flex;
    border: 1px solid #000;
    min-width: 800px;
    margin-bottom: 35px;

    .left-wrapper {
      display: flex;
      flex-direction: column;
      border-right: 1px solid #000;
      width: 50%;
    }

    .right-wrapper {
      width: 50%;
    }

    .driver {
      display: flex;
      justify-content: space-between;
      padding: 5px;

      &:not(:last-child) {
        border-bottom: 1px solid #000;
      }

      .name {
        display: flex;
        align-items: center;
        gap: 15px;
      }

      h6 {
        font-size: 10px;
        margin: 0;
        font-weight: 700;
      }

      span {
        font-size: 10px;
        margin: 0;
      }
    }

    .id {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  .second-table {
    display: flex;
    flex-direction: column;
    margin-bottom: 35px;

    &-body {
      max-width: 100%;
      display: flex;
      border: 1px solid #000;

      .vehicle {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        &:not(:last-child) {
          border-right: 1px solid #000;
        }

        h6 {
          width: 100%;
          text-align: center;
          border-bottom: 1px solid #000;
          font-weight: 700;
        }
      }
    }
  }

  .third-table {
    display: flex;
    flex-direction: column;
    border: 1px solid #000;

    &-header {
      display: flex;
      border-bottom: 1px solid #000;

      h6 {
        width: 100%;
        padding: 5px;
        font-weight: 700;

        &:not(:last-child) {
          border-right: 1px solid #000;
        }
      }
    }

    &-infos {
      display: flex;
      align-items: center;
      width: 100%;

      &:not(:last-child) {
        border-bottom: 1px solid #000;
      }

      span {
        font-size: 10px;
        width: 11.11%;
        margin-left: 40px;
      }

      p {
        display: flex;
        flex-direction: column;
        font-size: 10px;
        width: 11.11%;
        margin: 0;
        color: black;

        span {
          font-size: 9px;
          color: rgb(136, 136, 136);
        }
      }
    }
  }
}
</style>
